module.exports = __webpack_public_path__ + "static/media/apiCover.9ca0d82e.jpg";